import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  listCertificateClassify({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/listCertificateClassify`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteCertificateClassify({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/deleteCertificateClassify`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateCertificateClassify({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/updateCertificateClassify`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  listCertificate({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/listCertificate`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateCertificate({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/updateCertificate`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteCertificate({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/certificate/deleteCertificate`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateGroupQrCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/updateGroupQrCode`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  selectGroupQrCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectGroupQrCode`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}









